// Fake reconcile data for testing the ReconcileDialog

export const fakeReconcileData = {
  // New medications from external sources that need to be reconciled
  newMedications: [
    {
      id: 'new_med_001',
      name: 'Metformin',
      dose: '500 mg',
      frequencyNumber: '2',
      frequencyPeriod: 'per day',
      isActive: true,
      isNew: true
    },
    {
      id: 'new_med_002',
      name: 'Atorvastatin',
      dose: '20 mg',
      frequencyNumber: '1',
      frequencyPeriod: 'per day',
      isActive: true,
      isNew: true
    },
    {
      id: 'new_med_003',
      name: 'Omeprazole',
      dose: '20 mg',
      frequencyNumber: '1',
      frequencyPeriod: 'per day',
      isActive: false,
      isNew: false
    },
    {
      id: 'new_med_004',
      name: 'Lisinopril',
      dose: '5 mg',
      frequencyNumber: '1',
      frequencyPeriod: 'per day',
      isActive: false,
      isNew: false
    }
  ],
  // New allergies from external sources that need to be reconciled
  newAllergies: [
    {
      id: 'new_allergy_001',
      allergen: 'Sulfa drugs',
      severity: 'moderate',
      reactions: 'Skin rash, fever, joint pain',
      isNew: true
    },
    {
      id: 'new_allergy_002',
      allergen: 'Codeine',
      severity: 'mild',
      reactions: 'Nausea, drowsiness, constipation',
      isNew: true
    },
    {
      id: 'new_allergy_003',
      allergen: 'Penicillin',
      severity: 'severe',
      reactions: 'Anaphylaxis, difficulty breathing',
      isNew: false
    },
    {
      id: 'new_allergy_004',
      allergen: 'Peanuts',
      severity: 'severe',
      reactions: 'Swelling, hives, itching',
      isNew: false
    }
  ]
};
